// // // // import React from 'react';
// // // // import { AcademicCapIcon, CalendarIcon, ClipboardIcon, UserGroupIcon, CurrencyRupeeIcon, ChatBubbleBottomCenterTextIcon, TruckIcon ,  ChartBarIcon,
// // // //   CalendarDaysIcon,
// // // //   ClipboardDocumentListIcon,
// // // //   DocumentTextIcon,
// // // //   BellIcon,
// // // //   PencilSquareIcon,
// // // //   ClipboardDocumentCheckIcon, // for Assignment Management
// // // //   ExclamationCircleIcon,      // for Complaint Management
// // // //   DocumentIcon,               // for Document Management
// // // //   BookOpenIcon ,
// // // //   UsersIcon,} from '@heroicons/react/24/outline';

// // // // const features = [
// // // //   { title: 'AI-Driven Admission & Registration', icon: <UserGroupIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Personalized Dashboards', icon: <AcademicCapIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Smart Attendance System & Management', icon: <CalendarIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Assignment Management', icon: < ClipboardDocumentCheckIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'AI-Powered Quiz Generation', icon: <PencilSquareIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Salary and Finance Management', icon: <CurrencyRupeeIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Complaint Management', icon: <ExclamationCircleIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Real-Time Bus Tracking', icon: <TruckIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Timetable & Notice Management', icon: <CalendarIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   // { title: 'AI-based Attendance', icon: <UserGroupIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Report Cards & Analytics', icon: <ClipboardIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'AI-Based Answer Sheet Evaluation', icon: <AcademicCapIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Parent-Teachers Communication', icon: <ChatBubbleBottomCenterTextIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Student-Teachers Communication', icon: <ChatBubbleBottomCenterTextIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Library Management', icon: <BookOpenIcon className="h-8 w-8 text-indigo-500" /> },
  
// // // //   // { title: 'Staff Directory', icon: <UserGroupIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Document Management', icon: <DocumentIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Notification System', icon: <BellIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Leave Request Management', icon: <CalendarDaysIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'AI-Powered Performance Insights', icon: <ChartBarIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'AI Chatbot Assistant (Chatfires)', icon: <ChatBubbleBottomCenterTextIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Lunch Box Analysis', icon: <ClipboardDocumentListIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'AI-Powered Lecture Summarization', icon: <DocumentTextIcon className="h-8 w-8 text-indigo-500" /> },
// // // //   { title: 'Class Behavior Analysis', icon: <UsersIcon className="h-8 w-8 text-indigo-500" /> },
 

// // // // ];

// // // // const FeaturesGrid = () => {
// // // //   return (
// // // //     <section className=" py-20 px-6 md:px-16 text-white">
// // // //       <div className="max-w-7xl mx-auto">
// // // //         <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">Discover What We Offer</h2>
// // // //         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
// // // //           {features.map((feature, index) => (
// // // //             <div
// // // //               key={index}
// // // //               className="bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-lg p-6 shadow-md transition-all duration-300 hover:shadow-xl"
// // // //             >
// // // //               <div className="flex items-center gap-4 mb-3">
// // // //                 {feature.icon}
// // // //                 <h3 className="text-lg font-semibold">{feature.title}</h3>
// // // //               </div>
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       </div>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default FeaturesGrid;

// // // import React from 'react';
// // // import {
// // //   AcademicCapIcon, CalendarIcon, ClipboardIcon, UserGroupIcon, CurrencyRupeeIcon,
// // //   ChatBubbleBottomCenterTextIcon, TruckIcon, ChartBarIcon, CalendarDaysIcon,
// // //   ClipboardDocumentListIcon, DocumentTextIcon, BellIcon, PencilSquareIcon,
// // //   ClipboardDocumentCheckIcon, ExclamationCircleIcon, DocumentIcon, BookOpenIcon, UsersIcon,
// // // } from '@heroicons/react/24/outline';

// // // const groups = [
// // //   {
// // //     name: 'Academics',
// // //     blurb: 'Everything for the classroom, from admission to report card.',
// // //     items: [
// // //       { title: 'AI-driven admission & registration', icon: UserGroupIcon },
// // //       { title: 'Personalized dashboards', icon: AcademicCapIcon },
// // //       { title: 'Assignment management', icon: ClipboardDocumentCheckIcon },
// // //       { title: 'AI-powered quiz generation', icon: PencilSquareIcon },
// // //       { title: 'AI-based answer sheet evaluation', icon: AcademicCapIcon },
// // //       { title: 'Report cards & analytics', icon: ClipboardIcon },
// // //       { title: 'Library management', icon: BookOpenIcon },
// // //       { title: 'AI-powered lecture summarization', icon: DocumentTextIcon },
// // //     ],
// // //   },
// // //   {
// // //     name: 'Operations',
// // //     blurb: 'The daily running of the school, kept in one place.',
// // //     items: [
// // //       { title: 'Smart attendance system & management', icon: CalendarIcon },
// // //       { title: 'Salary and finance management', icon: CurrencyRupeeIcon },
// // //       { title: 'Real-time bus tracking', icon: TruckIcon },
// // //       { title: 'Timetable & notice management', icon: CalendarIcon },
// // //       { title: 'Document management', icon: DocumentIcon },
// // //       { title: 'Leave request management', icon: CalendarDaysIcon },
// // //     ],
// // //   },
// // //   {
// // //     name: 'Communication',
// // //     blurb: 'Keep parents, teachers and students on the same page.',
// // //     items: [
// // //       { title: 'Complaint management', icon: ExclamationCircleIcon },
// // //       { title: 'Parent–teacher communication', icon: ChatBubbleBottomCenterTextIcon },
// // //       { title: 'Student–teacher communication', icon: ChatBubbleBottomCenterTextIcon },
// // //       { title: 'Notification system', icon: BellIcon },
// // //       { title: 'AI chatbot assistant (Chatfires)', icon: ChatBubbleBottomCenterTextIcon },
// // //     ],
// // //   },
// // //   {
// // //     name: 'Insights',
// // //     blurb: 'See patterns you\'d otherwise only notice too late.',
// // //     items: [
// // //       { title: 'AI-powered performance insights', icon: ChartBarIcon },
// // //       { title: 'Lunch box analysis', icon: ClipboardDocumentListIcon },
// // //       { title: 'Class behavior analysis', icon: UsersIcon },
// // //     ],
// // //   },
// // // ];

// // // const FeaturesGrid = () => {
// // //   return (
// // //     <section className="py-20 px-6 md:px-16 bg-white">
// // //       <div className="max-w-7xl mx-auto">
// // //         <div className="text-center max-w-2xl mx-auto mb-16">
// // //           <h2 className="font-['Fraunces',serif] text-3xl md:text-4xl text-[#101826]">
// // //             One platform, every part of the school
// // //           </h2>
// // //           <p className="text-[#5A6478] font-['Sora',sans-serif] mt-3 text-lg">
// // //             Built for schools in India, from a single classroom to a multi-branch group.
// // //           </p>
// // //         </div>

// // //         <div className="space-y-14">
// // //           {groups.map((group) => (
// // //             <div key={group.name} className="grid md:grid-cols-[220px_1fr] gap-8 md:gap-12">
// // //               <div className="border-l-2 border-[#E8A63C] pl-5 md:sticky md:top-24 md:self-start">
// // //                 <h3 className="font-['Sora',sans-serif] text-lg font-semibold text-[#163863]">
// // //                   {group.name}
// // //                 </h3>
// // //                 <p className="text-[#5A6478] font-['Sora',sans-serif] text-sm mt-1.5 max-w-[200px]">
// // //                   {group.blurb}
// // //                 </p>
// // //               </div>

// // //               <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
// // //                 {group.items.map((feature) => {
// // //                   const Icon = feature.icon;
// // //                   return (
// // //                     <div key={feature.title} className="flex items-start gap-3 py-1">
// // //                       <Icon className="h-5 w-5 text-[#2E63B8] mt-0.5 shrink-0" />
// // //                       <span className="font-['Sora',sans-serif] text-[15px] text-[#101826]">
// // //                         {feature.title}
// // //                       </span>
// // //                     </div>
// // //                   );
// // //                 })}
// // //               </div>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default FeaturesGrid;

// // import React from 'react';
// // import {
// //   AcademicCapIcon, CalendarIcon, ClipboardIcon, UserGroupIcon, CurrencyRupeeIcon,
// //   ChatBubbleBottomCenterTextIcon, TruckIcon, ChartBarIcon, CalendarDaysIcon,
// //   ClipboardDocumentListIcon, DocumentTextIcon, BellIcon, PencilSquareIcon,
// //   ClipboardDocumentCheckIcon, ExclamationCircleIcon, DocumentIcon, BookOpenIcon, UsersIcon,
// // } from '@heroicons/react/24/outline';

// // const groups = [
// //   {
// //     name: 'Academics',
// //     blurb: 'Everything for the classroom, from admission to report card.',
// //     items: [
// //       { title: 'AI-driven admission & registration', icon: UserGroupIcon },
// //       { title: 'Personalized dashboards', icon: AcademicCapIcon },
// //       { title: 'Assignment management', icon: ClipboardDocumentCheckIcon },
// //       { title: 'AI-powered quiz generation', icon: PencilSquareIcon },
// //       { title: 'AI-based answer sheet evaluation', icon: AcademicCapIcon },
// //       { title: 'Report cards & analytics', icon: ClipboardIcon },
// //       { title: 'Library management', icon: BookOpenIcon },
// //       { title: 'AI-powered lecture summarization', icon: DocumentTextIcon },
// //     ],
// //   },
// //   {
// //     name: 'Operations',
// //     blurb: 'The daily running of the school, kept in one place.',
// //     items: [
// //       { title: 'Smart attendance system & management', icon: CalendarIcon },
// //       { title: 'Salary and finance management', icon: CurrencyRupeeIcon },
// //       { title: 'Real-time bus tracking', icon: TruckIcon },
// //       { title: 'Timetable & notice management', icon: CalendarIcon },
// //       { title: 'Document management', icon: DocumentIcon },
// //       { title: 'Leave request management', icon: CalendarDaysIcon },
// //     ],
// //   },
// //   {
// //     name: 'Communication',
// //     blurb: 'Keep parents, teachers and students on the same page.',
// //     items: [
// //       { title: 'Complaint management', icon: ExclamationCircleIcon },
// //       { title: 'Parent–teacher communication', icon: ChatBubbleBottomCenterTextIcon },
// //       { title: 'Student–teacher communication', icon: ChatBubbleBottomCenterTextIcon },
// //       { title: 'Notification system', icon: BellIcon },
// //       { title: 'AI chatbot assistant (Chatfires)', icon: ChatBubbleBottomCenterTextIcon },
// //     ],
// //   },
// //   {
// //     name: 'Insights',
// //     blurb: "See patterns you'd otherwise only notice too late.",
// //     items: [
// //       { title: 'AI-powered performance insights', icon: ChartBarIcon },
// //       { title: 'Lunch box analysis', icon: ClipboardDocumentListIcon },
// //       { title: 'Class behavior analysis', icon: UsersIcon },
// //     ],
// //   },
// // ];

// // const FeaturesGrid = () => {
// //   return (
// //     <section id="features" className="scroll-mt-[92px] py-20 px-6 md:px-16 bg-white w-full">
// //       <div className="max-w-7xl mx-auto">
// //         <div className="text-center max-w-2xl mx-auto mb-16">
// //           <h2 className="font-['Fraunces',serif] text-3xl md:text-4xl text-[#101826]">
// //             One platform, every part of the school
// //           </h2>
// //           <p className="text-[#5A6478] font-['Sora',sans-serif] mt-3 text-lg">
// //             Built for schools in India, from a single classroom to a multi-branch group.
// //           </p>
// //         </div>

// //         <div className="space-y-14">
// //           {groups.map((group) => (
// //             <div key={group.name} className="grid md:grid-cols-[220px_1fr] gap-8 md:gap-12">
// //               <div className="border-l-2 border-[#E8A63C] pl-5 md:sticky md:top-[92px] md:self-start">
// //                 <h3 className="font-['Sora',sans-serif] text-lg font-semibold text-[#163863]">
// //                   {group.name}
// //                 </h3>
// //                 <p className="text-[#5A6478] font-['Sora',sans-serif] text-sm mt-1.5 max-w-[200px]">
// //                   {group.blurb}
// //                 </p>
// //               </div>

// //               <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
// //                 {group.items.map((feature) => {
// //                   const Icon = feature.icon;
// //                   return (
// //                     <div key={feature.title} className="flex items-start gap-3 py-1">
// //                       <Icon className="h-5 w-5 text-[#2E63B8] mt-0.5 shrink-0" />
// //                       <span className="font-['Sora',sans-serif] text-[15px] text-[#101826]">
// //                         {feature.title}
// //                       </span>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default FeaturesGrid;


// import React from 'react';
// import {
//   AcademicCapIcon, CalendarIcon, ClipboardIcon, UserGroupIcon, CurrencyRupeeIcon,
//   ChatBubbleBottomCenterTextIcon, TruckIcon, ChartBarIcon, CalendarDaysIcon,
//   ClipboardDocumentListIcon, DocumentTextIcon, BellIcon, PencilSquareIcon,
//   ClipboardDocumentCheckIcon, ExclamationCircleIcon, DocumentIcon, BookOpenIcon, UsersIcon,
// } from '@heroicons/react/24/outline';

// const groups = [
//   {
//     name: 'Academics',
//     blurb: 'Everything for the classroom, from admission to report card.',
//     items: [
//       { title: 'AI-driven admission & registration', icon: UserGroupIcon },
//       { title: 'Personalized dashboards', icon: AcademicCapIcon },
//       { title: 'Assignment management', icon: ClipboardDocumentCheckIcon },
//       { title: 'AI-powered quiz generation', icon: PencilSquareIcon },
//       { title: 'AI-based answer sheet evaluation', icon: AcademicCapIcon },
//       { title: 'Report cards & analytics', icon: ClipboardIcon },
//       { title: 'Library management', icon: BookOpenIcon },
//       { title: 'AI-powered lecture summarization', icon: DocumentTextIcon },
//     ],
//   },
//   {
//     name: 'Operations',
//     blurb: 'The daily running of the school, kept in one place.',
//     items: [
//       { title: 'Smart attendance system & management', icon: CalendarIcon },
//       { title: 'Salary and finance management', icon: CurrencyRupeeIcon },
//       { title: 'Real-time bus tracking', icon: TruckIcon },
//       { title: 'Timetable & notice management', icon: CalendarIcon },
//       { title: 'Document management', icon: DocumentIcon },
//       { title: 'Leave request management', icon: CalendarDaysIcon },
//     ],
//   },
//   {
//     name: 'Communication',
//     blurb: 'Keep parents, teachers and students on the same page.',
//     items: [
//       { title: 'Complaint management', icon: ExclamationCircleIcon },
//       { title: 'Parent–teacher communication', icon: ChatBubbleBottomCenterTextIcon },
//       { title: 'Student–teacher communication', icon: ChatBubbleBottomCenterTextIcon },
//       { title: 'Notification system', icon: BellIcon },
//       { title: 'AI chatbot assistant (Chatfires)', icon: ChatBubbleBottomCenterTextIcon },
//     ],
//   },
//   {
//     name: 'Insights',
//     blurb: "See patterns you'd otherwise only notice too late.",
//     items: [
//       { title: 'AI-powered performance insights', icon: ChartBarIcon },
//       { title: 'Lunch box analysis', icon: ClipboardDocumentListIcon },
//       { title: 'Class behavior analysis', icon: UsersIcon },
//     ],
//   },
// ];

// const FeaturesGrid = () => {
//   return (
//     <section id="facility" className="scroll-mt-[88px] py-20 px-6 md:px-16 bg-white w-full">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center max-w-2xl mx-auto mb-16">
//           <h2 className="font-['Fraunces',serif] text-3xl md:text-4xl text-[#101826]">
//             One platform, every part of the school
//           </h2>
//           <p className="text-[#5A6478] font-['Sora',sans-serif] mt-3 text-lg">
//             Built for schools in India, from a single classroom to a multi-branch group.
//           </p>
//         </div>

//         <div className="space-y-14">
//           {groups.map((group) => (
//             <div key={group.name} className="grid md:grid-cols-[220px_1fr] gap-8 md:gap-12">
//               <div className="border-l-2 border-[#E8A63C] pl-5 md:sticky md:top-[88px] md:self-start">
//                 <h3 className="font-['Sora',sans-serif] text-lg font-semibold text-[#163863]">
//                   {group.name}
//                 </h3>
//                 <p className="text-[#5A6478] font-['Sora',sans-serif] text-sm mt-1.5 max-w-[200px]">
//                   {group.blurb}
//                 </p>
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
//                 {group.items.map((feature) => {
//                   const Icon = feature.icon;
//                   return (
//                     <div key={feature.title} className="flex items-start gap-3 py-1">
//                       <Icon className="h-5 w-5 text-[#2E63B8] mt-0.5 shrink-0" />
//                       <span className="font-['Sora',sans-serif] text-[15px] text-[#101826]">
//                         {feature.title}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeaturesGrid;


import React from 'react';
import {
  AcademicCapIcon, CalendarIcon, ClipboardIcon, UserGroupIcon, CurrencyRupeeIcon,
  ChatBubbleBottomCenterTextIcon, TruckIcon, ChartBarIcon, CalendarDaysIcon,
  ClipboardDocumentListIcon, DocumentTextIcon, BellIcon, PencilSquareIcon,
  ClipboardDocumentCheckIcon, ExclamationCircleIcon, DocumentIcon, BookOpenIcon, UsersIcon,
} from '@heroicons/react/24/outline';

const groups = [
  {
    name: 'Academics',
    blurb: 'Everything for the classroom, from admission to report card.',
    items: [
      { title: 'AI-driven admission & registration', icon: UserGroupIcon },
      { title: 'Personalized dashboards', icon: AcademicCapIcon },
      { title: 'Assignment management', icon: ClipboardDocumentCheckIcon },
      { title: 'AI-powered quiz generation', icon: PencilSquareIcon },
      { title: 'AI-based answer sheet evaluation', icon: AcademicCapIcon },
      { title: 'Report cards & analytics', icon: ClipboardIcon },
      { title: 'Library management', icon: BookOpenIcon },
      { title: 'AI-powered lecture summarization', icon: DocumentTextIcon },
    ],
  },
  {
    name: 'Operations',
    blurb: 'The daily running of the school, kept in one place.',
    items: [
      { title: 'Smart attendance system & management', icon: CalendarIcon },
      { title: 'Salary and finance management', icon: CurrencyRupeeIcon },
      { title: 'Real-time bus tracking', icon: TruckIcon },
      { title: 'Timetable & notice management', icon: CalendarIcon },
      { title: 'Document management', icon: DocumentIcon },
      { title: 'Leave request management', icon: CalendarDaysIcon },
    ],
  },
  {
    name: 'Communication',
    blurb: 'Keep parents, teachers and students on the same page.',
    items: [
      { title: 'Complaint management', icon: ExclamationCircleIcon },
      { title: 'Parent–teacher communication', icon: ChatBubbleBottomCenterTextIcon },
      { title: 'Student–teacher communication', icon: ChatBubbleBottomCenterTextIcon },
      { title: 'Notification system', icon: BellIcon },
      { title: 'AI chatbot assistant (Chatfires)', icon: ChatBubbleBottomCenterTextIcon },
    ],
  },
  {
    name: 'Insights',
    blurb: "See patterns you'd otherwise only notice too late.",
    items: [
      { title: 'AI-powered performance insights', icon: ChartBarIcon },
      { title: 'Lunch box analysis', icon: ClipboardDocumentListIcon },
      { title: 'Class behavior analysis', icon: UsersIcon },
    ],
  },
];

const FeaturesGrid = () => {
  return (
    <section id="facility" className="scroll-mt-[88px] py-20 px-6 md:px-16 bg-white w-full">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="font-['Fraunces',serif] text-3xl md:text-4xl text-[#101826]">
            One platform, every part of the school
          </h2>
          <p className="text-[#5A6478] font-['Sora',sans-serif] mt-3 text-lg">
            Built for schools in India, from a single classroom to a multi-branch group.
          </p>
        </div>

        <div className="space-y-14">
          {groups.map((group) => (
            <div key={group.name} className="grid md:grid-cols-[220px_1fr] gap-8 md:gap-12">
              <div className="relative pl-5 md:sticky md:top-[88px] md:self-start">
                {/* Short, vertically centered accent bar */}
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-10 w-0.5 rounded-full bg-[#E8A63C]" />
                <h3 className="font-['Sora',sans-serif] text-lg font-semibold text-[#163863]">
                  {group.name}
                </h3>
                <p className="text-[#5A6478] font-['Sora',sans-serif] text-sm mt-1.5 max-w-[200px]">
                  {group.blurb}
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
                {group.items.map((feature) => {
                  const Icon = feature.icon;
                  return (
                    <div key={feature.title} className="flex items-start gap-3 py-1">
                      <Icon className="h-5 w-5 text-[#2E63B8] mt-0.5 shrink-0" />
                      <span className="font-['Sora',sans-serif] text-[15px] text-[#101826]">
                        {feature.title}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
